import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import NextIcon from '@material-ui/icons/ArrowForwardIos';
import PrevIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@material-ui/core/Button';
import { staticsUrl } from '../../../config';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  quiz: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    '& > div': {
      position: 'relative',
      overflow: 'auto',
      textAlign: 'center',
      width: 500,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
    },
    '& p': {
      margin: '0 0 0.5em',
    },
  },
  quizDesc: {
    margin: '14px 0',
    lineHeight: 1.3,
    userSelect: 'none',
  },
  quizDesc2: {
    margin: '30px 0',
    lineHeight: 1.3,
    userSelect: 'none',
  },
  quizAction: {
    textAlign: 'center',
    marginTop: 10,
    '& button': {
      margin: '0 1px',
    },
    '& > div': {
      display: 'inline-block',
      padding: '0.25em 1em',
      color: '#a1008f',
      verticalAlign: 'middle',
      margin: '0 1px',
      borderRadius: 3,
    },
  },
  action: {
    textAlign: 'center',
    marginTop: 10,
    '& button': {
      margin: '0 1em',
    },
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  textSpeach: {
    background: '#eee',
    padding: '0 20px',
    borderRadius: 5,
  },
  images: {
    display: 'flex',
    width: '100%',
    marginTop: 10,
    justifyContent: 'space-between',
    '& > div': {
      width: '23%',
      paddingBottom: 20,
      position: 'relative',
      textAlign: 'center',
      marginTop: 20,
    },
    '& input': {
      width: '100%',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      textAlign: 'center',
    },
  },
  imgNav: {
    '& > button': {
      margin: '0 10px',
    }
  },
  '@media(max-width: 850px)': {

  }
}));

let timeout1 = 0;
let timeout2 = 0;

function NewExercise(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(null);
  const [ testFinished, setTestFinished ] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const len = exercise.sentences.length;
  const [ answers, setAnswers ] = useState(['', '', '', '']);

  const { images } = exercise;

  useEffect(() => {
    init();
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    }
    // eslint-disable-next-line
  }, []);

  const init = () => {
    startStats(type);
  }

  const drawImgs = () => {
    const handleChange = (ev, idx) => {
      const value = ev.target.value;
      const values = [ ...answers ];
      values[idx] = value;
      setAnswers(values);
    }

    return <div className={classes.images}>
      {images.map((img, idx) => <div key={idx}>
        <img src={staticsUrl + img.imageUrl} alt='' />
        <input
          type="text"
          value={answers[idx]}
          onChange={ev => handleChange(ev, idx)}
          autoCorrect="off"
          autoCapitalize="none"
          spellCheck={false}
        />
      </div>)}
    </div>
  }

  const drawQuiz = () => {

    const next = () => {
      action();
      if (no === null) {
        setNo(0);
        return;
      }
      if (no < len - 1) {
        setNo(no + 1);
      }
    }
    
    const prev = () => {
      action();
      if (no > 0) setNo(no - 1);
    }

    const cleanString = str => {
      if (str.indexOf('.') === str.length - 1) {
        str = str.substr(0, str.length - 1);
      }
      return str.trim().toLowerCase();
    }
    
    const checkAnswer = () => {
      action();
      let ok = true;
      answers.forEach((answer, idx) => {
        if (cleanString(answer) !== cleanString(images[idx].title)) ok = false;
      })
      if ( ok) {
        finishTest();
      } else {
        incorrect();
      }
    }

    const incorrect = () => {
      props.media.failure();
    }

    const finishTest = () => {
      props.media.finish();
      finishExercise();
      setTestFinished(true);
    }

    const btnActive = !(answers[0] !== '' && answers[1] !== '' && answers[2] !== '' && answers[3] !== '');

    return (
      <div className={classes.quiz}>
        <div>
         
          <div className={classes.quizIntro}>
            <div className={classes.introTitle} dangerouslySetInnerHTML={{__html: exercise.title}} />
            {images.length > 0 && drawImgs()}
            {no === null && <div className={classes.quizDesc} dangerouslySetInnerHTML={{__html: exercise.description}} />}
            {no !== null && <div className={classes.quizDesc2}>{exercise.sentences[no].text}</div>}
          </div>
          <div className={classes.action}>
            <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
            <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1}><NextIcon /></Button>
          </div>
          <div className={classes.quizAction}>
            {!testFinished && <Button variant="outlined" color="secondary" onClick={checkAnswer} disabled={btnActive}>
              Sprawdź
            </Button>}
            {testFinished && <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.wrapper}>
      <div>
        {drawQuiz()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(NewExercise);
